import { cn } from "../../lib/cn";

export function Spinner({ className, size = 16 }: { className?: string; size?: number }) {
  return (
    <svg className={cn("animate-spin", className)} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

/** The spec's loading state (§2.2): a spinner with the word "Loading…". */
export function Loading({ label = "Loading…", className }: { label?: string; className?: string }) {
  return (
    <div role="status" aria-live="polite" className={cn("inline-flex items-center gap-2 text-neutral-500 text-sm font-medium", className)}>
      <Spinner className="text-primary" />
      {label}
    </div>
  );
}
